<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-row>
        <h4>Timesheet Id : {{ previewItem.id }}</h4>
      </b-form-row>
      <b-form-group id="input-group-project-select" label="Project">
        <b-form-select
          :options="projects"
          v-model="form.project_id"
          required
        ></b-form-select>
      </b-form-group>
      <p v-if="feedbackProject" class="feedback_text">{{ feedbackProject }}</p>
      <b-form-group id="input-group-member-select" label="Member">
        <b-form-select
          :options="members"
          v-model="form.user_id"
          required
        ></b-form-select>
      </b-form-group>
      <p v-if="feedbackTeams" class="feedback_text">{{ feedbackTeams }}</p>
      <b-form-group
        id="input-group-2"
        label="Task Description"
        label-for="input-2"
      >
        <b-form-textarea
          v-model="form.log_description"
          placeholder="Enter Description"
          type="Text"
        >
        </b-form-textarea>
      </b-form-group>

      <b-form-group>
        <b-form-group
          id="input-group-date"
          label="Date"
          label-for="timesheet-datepicker"
        >
          <b-form-datepicker
            id="timesheet-datepicker"
            v-model="form.log_date"
            class="mb-2"
            required
            left
          ></b-form-datepicker>
        </b-form-group>
      </b-form-group>
      <p v-if="feedbackDate" class="feedback_text">{{ feedbackDate }}</p>
      <b-form-group
        id="input-group-hours"
        label="Hours and Mins"
        label-for="input-hours"
      >
        <b-form-input
          id="input-hours"
          v-model="form.working_hours"
          pattern="[0-9!:.]{0,5}"
          class="mb-2"
          @change="onChangeHours"
          placeholder="Enter time in either minutes or h:m format. E.g. 90 for 1 hour and 30 mins, or 3: for 3 hours"
          required
        ></b-form-input>
        <p v-if="feedbackHours" class="feedback_text">{{ feedbackHours }}</p>
      </b-form-group>
      <b-btn type="submit" variant="primary">Update</b-btn>
      <b-btn @click="closeModal($event.target)" variant="secondary"
        >Cancel</b-btn
      >
      <b-btn @click="deleteSheet" variant="danger">Delete</b-btn>
    </b-form>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {strIs} from "@/Utilites/helper.js";

import {
  convertHMSFormatInputToHours,
  convertToHm,
  HHMMFormat,
} from "@/Utilites/timerHelper";
export default {
  name: "EditTimeSheet",
  props: ["previewItem", "modalId", "projectList", "memberList"],
  data() {
    return {
      form: {},
      feedbackProject: null,
      feedbackTeams: null,
      feedbackDate: null,
      feedbackHours: null,
      members: [{value: null, text: "---Select---"}],
      projects: [{value: null, text: "---Select---"}],
    };
  },
  computed: {
    ...mapGetters(["getTimeLogsOfAllUser"]),
  },
  mounted() {
    this.projects.push(...this.projectList);
    this.members.push(...this.memberList);
    this.form = {...this.previewItem};
    this.form.working_hours = convertToHm(this.form.working_hours * 3600);
  },
  methods: {
    ...mapActions([
      "updateTimeSheet",
      "deleteTimeSheet",
      "showLoadingProcess",
      "closeLoading",
    ]),
    convertToHms: convertToHm,
    onChangeHours(value) {
      this.form.working_hours = HHMMFormat(value);
    },
    checkInfo() {
      const error = "This cannot be empty";
      this.feedbackProject = strIs(this.form.project_id) ? null : error;
      this.feedbackTeams = strIs(this.form.user_id) ? null : error;
      this.feedbackDate = strIs(this.form.log_date) ? null : error;
      this.feedbackHours = strIs(this.form.working_hours) ? null : error;
      return (
        !this.feedbackProject &&
        !this.feedbackTeams &&
        !this.feedbackDate &&
        !this.feedbackHours
      );
    },
    async onSubmit(evt) {
      if (this.checkInfo()) {
        evt.preventDefault();
        await this.showLoadingProcess();
        try {
          await this.closeModal();
          this.form.working_hours = convertHMSFormatInputToHours(
            this.form.working_hours
          );
          this.form.task_description = this.form.log_description;
          this.form.timer_log_date = this.form.log_date;
          this.form.hours_with_timer = this.form.working_hours;
          this.form.hours = this.form.working_hours;
          await this.updateTimeSheet(this.form);
          this.$emit("update-timesheet", this.getTimeLogsOfAllUser);
        } catch (err) {
          console.log("Error" + JSON.stringify(err));
        } finally {
          await this.closeLoading();
        }
      } else {
        console.log("Empty Fields");
      }
    },

    async deleteSheet() {
      await this.showLoadingProcess();
      try {
        await this.deleteTimeSheet(this.form.id);
        this.$emit("update-timesheet", this.getTimeLogsOfAllUser);
        await this.closeModal();
      } catch (err) {
        console.log("Error" + JSON.stringify(err));
      } finally {
        await this.closeLoading();
        await this.closeModal();
      }
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>

<style scoped>
.feedback_text {
  color: red;
}
</style>
